import React, { Component,Children} from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { getMonth, getYear,format } from 'date-fns';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {URL_IMG} from '../../configs/urlConfigs';
import{NO_AVAILABILITY} from '../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_CREW_UNAVAILABILITY, LBL_SEARCH_CREW_NAME, LBL_SEARCHING, LBL_FROM, LBL_TO, LBL_SHIFT_TITLE_SEPARATOR, LBL_FILTER } from '../../configs/labelConfigs'; // LBL_CLEAR_FILTERS
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH,LOGIN_AFFILIATE_GROUP,RANDOM_COLORS,ROUTE_AFFILIATE_CREW_PROFILE,SEARCH_TEXT_COUNT,CREW_MAX_RATING} from '../../configs/staticConfigs';

import * as types from '../../actions';
import { serverTimeAction} from '../../actions/commonActions';
import {crewUnavailabilityAction,crewUnavailabilityPerDateAction,unavailableCrewListAction} from '../../actions/unavailabilityActions';

import {titleCase} from '../../utils/changeCase'; 
import {checkPermissions} from '../../utils/permissions';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import { converDateToLocal, converDateToLocalWithOutOffset } from '../../utils/commonUtilities';

import Filter from '../commons/helpers/filterBy';
import FilterUnavailability from './filterUnavailability';

import SkillIcon from "../commons/helpers/skillIcon"; 

const localizer = momentLocalizer(moment)

class Unavailability extends Component {

   constructor(props){
      super(props)

      this.state = {       
         selectedDate:'',
         rand :Math.floor(Math.random()*RANDOM_COLORS.length),
         searchCrew:0,   
         curMonth:'',
         curYear:'',
         defaultStartDate: new Date(),
         departmentsList: [],
         selDepartments:[],
         deptMultiSelList: [], 
         serverDateTimeLoaded:false,
         departmentListLoaded:false,
         unavailabalityListLoaded: false,
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},
         isFilterOn: false, 
         unavailabilityDetailsPerDate: [],
      } 
   }       

   onSearchCrew = (query) =>{
      if(query.length>=SEARCH_TEXT_COUNT){
         this.props.unavailableCrewListAction({crewName:query});
      }        
   }

   unavailableDate = (date)=>{
      let {searchCrew} = this.state;
      let dateSelected = format(new Date(date.start),"yyyy-MM-dd");
      this.props.crewUnavailabilityPerDateAction({date:dateSelected,crewId:searchCrew,filtersData:this.state.filtersData});
      this.setState({selectedDate:new Date(date.start)});
   } 

   onSelectCrew = (selected) =>{
      let {selectedDate,curYear,curMonth} = this.state;
      if(selected.length>0) {
         let selectedCrewId = selected[0].id;
         let date = '';
         if(selectedDate===''){
            date = format(new Date(),"yyyy-MM-dd");
         }else{
            date = format(selectedDate,"yyyy-MM-dd");
         }
         this.props.crewUnavailabilityAction({year:curYear,month:curMonth,crewId:selectedCrewId,filtersData:this.state.filtersData});
         this.props.crewUnavailabilityPerDateAction({date:date,crewId:selectedCrewId,filtersData:this.state.filtersData});
         this.setState({searchCrew:selectedCrewId});
      }else{
         this.props.crewUnavailabilityAction({year:curYear,month:curMonth,filtersData:this.state.filtersData});
         this.setState({searchCrew:0});
      }
   }

   goToBack = (toolbar) => {
      let {searchCrew} = this.state;
      toolbar.date.setMonth(toolbar.date.getMonth() - 1);
      let month= format(toolbar.date,'M');
      toolbar.onNavigate('prev');
      this.props.crewUnavailabilityAction({month:month,year:toolbar.date.getFullYear(),crewId:searchCrew,filtersData:this.state.filtersData});
      this.setState({curMonth:month,curYear:toolbar.date.getFullYear()});
   }
  
   goToNext = (toolbar) => {
      let {searchCrew} = this.state;
      toolbar.date.setMonth(toolbar.date.getMonth() + 1);
      let month= format(toolbar.date,'M');
      toolbar.onNavigate('next');
      this.props.crewUnavailabilityAction({month:month,year:toolbar.date.getFullYear(),crewId:searchCrew,filtersData:this.state.filtersData});
      this.setState({curMonth:month,curYear:toolbar.date.getFullYear()});
   }

   customToolbar = (toolbar) =>{
      return (
        <div className="rbc-toolbar">          
          <span className="rbc-toolbar-label">{toolbar.label}</span>
          <span className="rbc-btn-group">
            <button onClick={()=>this.goToBack(toolbar)}><i className="fa fa-angle-left"></i></button>
            <button onClick={()=>this.goToNext(toolbar)}><i className="fa fa-angle-right"></i></button>
          </span>
        </div>      
      )
   }   

   ColoredDateCellWrapper = ({ children, value }) =>{
      let selDate = this.state.selectedDate;
      let valueDay = value.getFullYear()+'/'+value.getMonth()+'/'+value.getDate();
      let selDay = '';
      if(selDate!==''){
        selDay = selDate.getFullYear()+'/'+selDate.getMonth()+'/'+selDate.getDate();
      }  
      let cellStyle = React.cloneElement(Children.only(children), {
         //className:valueDay === selDay ? "yourclassname rbc-day-bg": "rbc-day-bg",
         style: {
          ...children.style,
          backgroundColor: valueDay === selDay ? "#d5e6ff": "",
        },         
      });  
      return cellStyle;  
   }

   eventStyleGetter = (event)=>{
      let backgroundColor = event.isShiftScheduled ? '#055556 !important' : '#558080 !important';
   
      let style = {
         backgroundColor: backgroundColor,             
      };
      return {
         className: event.isShiftScheduled?'shift-exist':'shift-not-exist',
         style: style
      };
   }

   componentDidMount() {
      this.props.serverTimeAction();
        const { location } = this.props;
        let timeZone =  getUserTimeZone(this.props.location);

        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
         if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
         }   
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
         }
        document.title = LBL_APP_NAME+" - "+LBL_CREW_UNAVAILABILITY;
   }

   componentDidUpdate(prevProps) { 
      const { isFilterOn } = this.props;
      if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
         let arrTimeResp = this.props.serverTimeListActivity.split('~~');
         if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
            // let defaultStartDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
            let defaultStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
            let month = getMonth(new Date(defaultStartDate.valueOf()))+1;
            let year  = getYear(new Date(defaultStartDate.valueOf()));
            let currentDate = format(new Date(defaultStartDate.valueOf()),"yyyy-MM-dd");
            this.setState({curMonth:month,curYear:year,defaultStartDate:defaultStartDate,serverDateTimeLoaded:true}, () => {
               if(this.state.departmentListLoaded && !this.state.unavailabalityListLoaded) {
                  this.props.crewUnavailabilityAction({year:year,month:month,filtersData:this.state.filtersData});
                  this.props.crewUnavailabilityPerDateAction({date:currentDate,filtersData:this.state.filtersData});
               }
            });
         }
      }
      
      // RESPONSE IF UNAVAILABILITY IN A SELECTED DATE MAY HAVE MULTIPLE ITEMS OF SHIFT AND UNAVAILABILITY DATA SAME STAFF, SO STAFF DETAILS CAN BE REPEATED, TO AVOID THIS MERGE MULTIPLE UNAVAILABILITY DATA OF SAME STAFF INTO SINGLE RECORD 
      if(this.props.activity && this.props.activity !== prevProps.activity){ 
         let arrActivity = this.props.activity.split('~~');
         if(arrActivity[0]===types.CREW_UNAVAILABILITY_PER_DATE_SUCCESS){
            let arrCrewProfileIds = [];
            let arrTempUnAvailData = []; 
            let arrUnAvailData = [];
            let arrIds = this.props.unavailabilityPerDate.map((crewItem, idx) => {
               if(arrCrewProfileIds.includes(crewItem.crew_profile_id)) {
                  let arrNew = arrTempUnAvailData.map(tmpItem  => {
                     if(tmpItem.crew_profile_id==crewItem.crew_profile_id) {
                        return {...tmpItem, unavailData:[...tmpItem.unavailData,{from_date: crewItem.from_date, to_date: crewItem.to_date, ...crewItem.shift_details}]}
                     }
                     else {
                        return tmpItem; 
                     }
                  }
                  );
                  arrUnAvailData =  arrNew; 
               }
               else {
                  arrCrewProfileIds.push(crewItem.crew_profile_id); 
                  arrTempUnAvailData.push({...crewItem, unavailData:[{from_date: crewItem.from_date, to_date: crewItem.to_date, ...crewItem.shift_details}]});
                  arrUnAvailData.push({...crewItem, unavailData:[{from_date: crewItem.from_date, to_date: crewItem.to_date, ...crewItem.shift_details}]});  
               }
               
               return crewItem.crew_profile_id; 
            });
            this.setState({unavailabilityDetailsPerDate: arrUnAvailData}); 
         }
      }

      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click(); 
      }
   }   

   formatUnavailabilityData(array){
      let timeZone =  getUserTimeZone(this.props.location);
      let {searchCrew} = this.state;

      let unvailability = [];
      if(array.length>0){
          array.map(item => {
              let unavailObj = {};  
              let title_date = "";
              let shift_details=item.shift_details ? item.shift_details : {};
              let shiftTitle = Object.keys(shift_details)?.length===0?'':shift_details.title+LBL_SHIFT_TITLE_SEPARATOR+shift_details.event_title; 
              unavailObj['id'] = Number(item.crew_profile_id);
              if(converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyy','-') === converDateToLocal(item.to_date,timeZone.utc_offset,'ddmmyyyy','-')){
                  title_date = converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyyhhmm','-')+' - '+converDateToLocal(item.to_date,timeZone.utc_offset,'hhmm','-') 
              }else{
                title_date = converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyyhhmm','-')+' - '+converDateToLocal(item.to_date,timeZone.utc_offset,'ddmmyyyyhhmm','-')
              }
              
              unavailObj['title'] = (searchCrew===0 && item?.crew_name ? (item.crew_name+' ') : '') + title_date +' '+ shiftTitle;       
              unavailObj['start'] = converDateToLocal(item.from_date,timeZone.utc_offset,'yyyymmddThhmmss','-'); 
              unavailObj['end'] = converDateToLocal(item.to_date,timeZone.utc_offset,'yyyymmddThhmmss','-'); 
              unavailObj['isShiftScheduled'] = (item?.shift && parseInt(item.shift)) ? true :  Object.keys(shift_details).length===0?false:true; 
              unvailability.push(unavailObj);
              return unvailability;
          });          
      }
      return unvailability;
   }

   loadMultiSelDeptValues() {
      let allDept = []; 
      if(this.state.departmentsList.length > 0) {
         let tmpObj = {}; 
         let len = this.state.departmentsList.length; 
         let deptId = 0;  
         this.state.departmentsList.forEach((item,index) => { 
             if(len===1) {
                 tmpObj = {value:item.id, label:titleCase(item.name), inputVal:item.id}; 
                 deptId = item.id;   
             }
             else {
                 tmpObj = {value:item.id, label:titleCase(item.name)}; 
             }
            allDept.push(tmpObj); 
         }) 
         
          if(len===1 && deptId > 0) {
              this.setState({selDepartments:[deptId],deptMultiSelList:allDept}); 
          }
          else {
              this.setState({deptMultiSelList:allDept}); 
          }
      }
   }

   handleChangeMultiSel = (selectedDepts) =>{
      let actUserDept = []; 
      selectedDepts.forEach((item) => {
         actUserDept.push(item.value);
      });
      this.setState({selDepartments:actUserDept}); 
   }

   handleChangeMultiSel = () => {

   }

   onApplyFilterButton = () => {
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let applyFilter = 0; 
      if(filtersData.filtersSelected > 0) applyFilter = 1; 
      this.setState({applyFilter:applyFilter, filtersData:filtersData,departmentListLoaded:true}, () => { 
         if(this.state.serverDateTimeLoaded) {  
            let currentDate = this.state.selectedDate===''?format(new Date(this.state.defaultStartDate.valueOf()),"yyyy-MM-dd"):format(this.state.selectedDate,"yyyy-MM-dd");
            this.props.crewUnavailabilityAction({year:this.state.curYear,month:this.state.curMonth,filtersData:this.state.filtersData});
            this.props.crewUnavailabilityPerDateAction({date:currentDate,filtersData:this.state.filtersData});
         }
      });
   }

   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');

      let filterByMenu = document.getElementById('filterByMenu');    
      filterByMenu.style.display     = 'block';   
      if(this.state.isFilterOn){
         filterByMenu.style.width='580px';
         filterByMenu.style.right='-580px';
      }else{
         filterByMenu.style.width='580px';
         filterByMenu.style.right='0';
      }
   }

   onCloseSlider = () => {
      let filterByMenu = document.getElementById('filterByMenu');  
      filterByMenu.style.display = 'none';
   }

   onResetFiltersButton = () => {  
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
         this.setState({resetFilterClicked,applyFilter:0,filtersData:{}}, () => { 
            // let month = this.state.curMonth;
            // let year  = this.state.curYear;
            // this.props.crewUnavailabilityAction({year:year,month:month,filtersData:this.state.filtersData});
            // let currentDate = this.state.selectedDate;
            // this.props.crewUnavailabilityPerDateAction({date:currentDate,filtersData:this.state.filtersData});
            if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
            }
            else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
            }
         });
      }
      else {
          this.setState({resetFilterClicked,applyFilter:0}); 
      }
   }

   listUnavailability = () => { 

   }
  
   render(){

      const {
         selectedDate,rand        
     } = this.state  

      const {status,unavailability,unavailableCrews} = this.props; 
      let isCrewView = checkPermissions("crew","view");
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
      }

      if(status===401 || status===403){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
         }else{
            return <Redirect to={ROUTE_REFRESH} />;
         }
      }     
     
      let timeZone =  getUserTimeZone(this.props.location);
      let unavailabilityList = this.formatUnavailabilityData(unavailability);  

      let headerDate = '';
      let day = '';
      if(selectedDate===''){
         headerDate = converDateToLocalWithOutOffset(this.state.defaultStartDate,"",'MonthdayYear','-');
         day = 'Today';
      }else{
         headerDate = format(new Date(selectedDate),'MMM dd yyyy');
         let currentDateObj = this.state.defaultStartDate;
         day = format(currentDateObj,'YYY/MM/dd')===format(selectedDate,'YYY/MM/dd')?'Today':format(new Date(selectedDate),'EEEE');     

      }
      let todayDate = this.state.defaultStartDate;     

      let formattedCrews = [];
      if(unavailableCrews.length>0){
         unavailableCrews.forEach(el => {
            formattedCrews.push({id:el.id,name:el.first_name+' '+el.last_name});
         });
      }

      return(
        <>
           <div className="col-md-12" style={{maxWidth:"calc(100vw - 78px)"}}>
                  <div className="box">                    
                     <div className='box-content unavailability'>
                        <div className="row">
                            <div className="col-md-8"> 
                                <Calendar
                                    localizer={localizer}
                                    views={['month']}
                                    defaultView = "month"
                                    defaultDate = {this.state.defaultStartDate}
                                    getNow={() => todayDate}
                                    components={{
                                    toolbar: this.customToolbar,
                                    dateCellWrapper: this.ColoredDateCellWrapper,
                                    }}
                                    events={unavailabilityList}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 600 }}
                                    popup={true}
                                    selectable={true}
                                    onSelectSlot={this.unavailableDate}
                                    eventPropGetter={this.eventStyleGetter}
                                   
                                />
                            </div>
                            <div className="col-md-4 "> {/* pt-2 */}
                              <div className='row'>
                                 <div className="dataTables_filter col-md-9 C">
                                       <AsyncTypeahead
                                          isLoading={false}
                                          name="name" 
                                          id="crewSearch"
                                          minLength={3}
                                          labelKey="name"
                                          onChange={selected => this.onSelectCrew(selected)}
                                          options={formattedCrews}
                                          placeholder={LBL_SEARCH_CREW_NAME}
                                          onSearch={this.onSearchCrew}
                                          searchText={LBL_SEARCHING}
                                          promptText={LBL_SEARCH_CREW_NAME}
                                          inputProps={{ className:'maxWidth300'}}
                                       />
                                 </div>
                                 <div className="col-md-3">
                                    <div className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'} >
                                       <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 450, hide: 250 }}
                                          overlay={<Tooltip id="filterIcon-tooltip" style={{
                                             opacity: 0.4,
                                             }}>
                                          {LBL_FILTER} 
                                       </Tooltip>}
                                       >
                                          <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                                       </OverlayTrigger>
                                    </div>
                                    {/* {this.state.applyFilter > 0 && 
                                    <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>} */}
                                 </div>
                              </div>
                              <div className="pt-3 mb-3 unavail-head">
                                 <span>{day} - {headerDate}</span>
                              </div>
                              {this.state.unavailabilityDetailsPerDate.length===0 &&
                                 <p className="font-14">{NO_AVAILABILITY}</p>
                              }
                              {
                                 this.state.unavailabilityDetailsPerDate.map((crew, index)  => {

                                    let imageClass = crew.chief_eligibility?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew.crew_name} title={crew.crew_name} />;

                                    if ((crew.crew_profile_picture) && crew.crew_profile_picture.trim().length > 0){
                                       profileImgTag = <img className={imageClass} src={crew.crew_profile_picture} alt={crew.crew_name} title={crew.crew_name} />;
                                    }else if(((!crew.crew_profile_picture) || crew.crew_profile_picture.trim().length===0) && crew.avatar_name && crew.avatar_name.trim().length > 0){
                                     
                                       profileImgTag = <div title={crew.crew_name} className={crew.chief_eligibility?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crew.profile_color}}>{crew.avatar_name}</div>; 
                                    }

                                   const chiefIcon = crew.chief_eligibility? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';

                                    // let unAvailBGC = '', ShiftTitle = ''; 
                                    // if(Object.keys(crew.shift_details)?.length===0) {
                                    //    unAvailBGC = 'rbc-event unavail-icon rbc-event-content text-white'; 
                                    // } else {
                                    //    unAvailBGC = 'rbc-event shift-unavail-icon rbc-event-content text-white';
                                    //    ShiftTitle = crew?.shift_details?.title ? (' - '+crew.shift_details.title) : '';
                                    // }
                                    // let fromDate = format(new Date(crew.from_date),'HH:mm');
                                    // let toDate = format(new Date(crew.to_date),'HH:mm');
                                    //   let fromDate = '', toDate = '';
                                    //   if(crew.from_date.substr(0, 10)!==crew.to_date.substr(0, 10)) {
                                    //       fromDate = converDateToLocal(crew.from_date,timeZone.utc_offset,'ddmmyyyyhhmm','-');
                                    //       toDate = converDateToLocal(crew.to_date,timeZone.utc_offset,'ddmmyyyyhhmm','-');
                                    //   }
                                    //   else {
                                    //       fromDate = converDateToLocal(crew.from_date,timeZone.utc_offset,'hhmm','-');
                                    //       toDate = converDateToLocal(crew.to_date,timeZone.utc_offset,'hhmm','-');
                                    //   }
                                    
                                   let crewProfileId = Number(crew.crew_profile_id);
                                   let crewRating = crew.crew_rating;
                                    return(
                                       <div className="card p-3 mb-3 text-muted" key={index}>
                                          <div className="crew">
                                             <div className="crew__aside">
                                                <div className="crew__thumb">
                                                {isCrewView && 
                                                  <a rel="noopener" href={ROUTE_AFFILIATE_CREW_PROFILE+'/'+crewProfileId}>{profileImgTag}</a>
                                                }{!isCrewView &&
                                                  <p>{profileImgTag}</p>
                                                }
                                                   
                                                </div>
                                                <span className="crew__badge">{crew.omnu_points}</span>
                                                </div>
                                             <div className="crew__content">
                                                <span>{chiefIcon}<small>{isCrewView && 
                                                  <a rel="noopener" href={ROUTE_AFFILIATE_CREW_PROFILE+'/'+crewProfileId}>{crew.crew_name}</a>
                                                  }
                                                  {!isCrewView &&
                                                      <p>{crew.crew_name}</p>
                                                  }
                                                  </small></span>
                                                <p className="mb-0"><small>{crew.pay_level_name}</small></p>
                                                <div>
                                                   <small>
                                                      {/* {crew.crew_skills.join(', ')} */}
                                                      {crew?.crew_skills && crew.crew_skills.length > 0 ? crew.crew_skills.map(item => { 
                                                                return item.icon_class && item.icon_class.trim().length > 0 ? <SkillIcon skillName={item.skill_name} iconClassName={'marginRight10 '+item.icon_class} /> : <span className='marginRight10'>{item.skill_name}</span>; 
                                                            }) : ''} 
                                                   </small>
                                                </div>
                                             </div>
                                          </div>
                                          <div className="crew-rate">
                                          <div className="crew__rating rating-display-only">
                                             {CREW_MAX_RATING.map(ratingNum => {
                                                if(Number(ratingNum) <= crewRating) {
                                                   return(
                                                   <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                )
                                                }else{
                                                   if(parseFloat(ratingNum)-0.5===parseFloat(crewRating)){
                                                         return(
                                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                         )
                                                   }else{
                                                         return(
                                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                         )
                                                   }
                                                   
                                                }                                                                                  
                                       }) }
                                       
                                             </div>
                                             {/* <div className={unAvailBGC+" h6 m-0 "}><small><i className="las la-clock"></i> {LBL_FROM+' '+fromDate+' '+LBL_TO.toLowerCase()+' '+toDate+' '+ShiftTitle}</small></div>    */}

                                             {crew?.unavailData && crew.unavailData.length > 0 ? crew.unavailData.map((item, idx) => { 
                                                let fromDate = '', toDate = '', unAvailBGC = '', ShiftTitle = ''; 
                                                if(item?.id && parseInt(item.id,10)) {
                                                   unAvailBGC = 'rbc-event shift-unavail-icon rbc-event-content text-white marginBottom5'; 
                                                   ShiftTitle = item?.title ? (' - '+item.title) : '';
                                                } else {
                                                   unAvailBGC = 'rbc-event unavail-icon rbc-event-content text-white marginBottom5';
                                                }
                                                if(item.from_date.substr(0, 10)!==item.to_date.substr(0, 10)) {
                                                    fromDate = converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyyhhmm','-');
                                                    toDate = converDateToLocal(item.to_date,timeZone.utc_offset,'ddmmyyyyhhmm','-');
                                                }
                                                else {
                                                    fromDate = converDateToLocal(item.from_date,timeZone.utc_offset,'hhmm','-');
                                                    toDate = converDateToLocal(item.to_date,timeZone.utc_offset,'hhmm','-');
                                                }
                                                return (<React.Fragment key={'key'+idx}><div className={unAvailBGC+" h6 "}><small><i className="las la-clock"></i> {LBL_FROM+' '+fromDate+' '+LBL_TO.toLowerCase()+' '+toDate+' '+ShiftTitle}</small></div></React.Fragment>)
                                             }) : <></> }

                                             {/* <a target="_blank" href={ROUTE_AFFILIATE_CREW_PROFILE+'/'+crewProfileId} className="float-right"><small>View Profile</small></a> */}
                                          </div>
                                       </div>
                                    )
                                 })
                              }       
                           </div>
                        </div>
                       
                     </div>
                  </div>
               </div>

               <Filter onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} >
                  <FilterUnavailability filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} onShowFilterBy={this.onShowFilterBy} />
               </Filter>
           
        </>
        )
    }

}
const mapStateToProps = (state) => {
      return {
         unavailability:state.unavailability.unavailability,     
         unavailabilityPerDate:state.unavailability.unavailabilityPerDate,  
         unavailableCrews:state.unavailability.unavailableCrews,
         status:state.unavailability.status,
         activity:state.unavailability.activity,      
         errorData:state.unavailability.errorData,
         serverTimeList: state.serverTimeList.serverTimeList,
         serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
         isFilterOn: state.commons.isFilterOn,
      }
};

const mapDispatchToProps = (dispatch) => {
      return bindActionCreators({
        crewUnavailabilityAction:crewUnavailabilityAction,
        crewUnavailabilityPerDateAction:crewUnavailabilityPerDateAction,
        unavailableCrewListAction:unavailableCrewListAction,
        serverTimeAction:serverTimeAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(Unavailability);